

const CITY_SORT_GROUPS = {
    0: ["Dubai", "Kalifornia", "Texas"],
    1: ["Amstetten", "Bad Ischl", "Baden", "Berlin", "Bratislava", "Budapest", "Dornbirn", "Düsseldorf", "Gmunden", "Graz", "Hamburg", "Interlaken", "Karlsruhe", "Klagenfurt", "Klosterneuburg", "Kufstein", "Leoben", "Linz-Urfahr", "Lisboa", "Luksemburg", "Malmö", "Mödling", "Neuss", "Oberwart", "Saalfelden", "Salzburg", "Schruns", "St. Johann / Pongau", "St. Johann / Tirol", "St.Pölten", "Tbilisi", "Tralee", "Varna", "Vienna", "Villach", "Vösendorf", "Wels", "Wuppertal", "Wörgl", "Zurich"],
    2: ["Toronto"],
    3: ["Calgary", "Kirchheim unter Teck"],
    4: ["Ontario", "Völklingen"],
    5: ["Duisburg", "Ottawa"],
    11: ["Alicante"],
    12: ["Limassol", "Ljubiana", "Paris"],
    13: ["Jõhvi", "Yerevan"],
    14: ["Apeldoorn", "Oulu", "Tallinn"],
    15: ["Tartu"],
    16: ["Hiiumaa", "Valencia"],
    17: ["Võrumaa"],
    18: ["Saaremaa", "Torino"],
    19: ["Fondi"],
    20: ["San Giorgio a Cremano"],
    30: ["Portogruaro"],
    40: ["Colonnella"],
    90: ["Krakow"],
    91: ["Warsaw"],
    92: ["Lublin"],
    93: ["Katowice"],
    94: ["Szczecin"],
    95: ["Wrocław"],
    96: ["Białystok"],
    97: ["Rzeszów"],
    98: ["Opole"],
    99: ["Bydgoszcz"],
    100: ["Bielsko-Biała"],
    101: ["Goleniow"],
    102: ["Poznań"],
    103: ["Glivice"],
    104: ["Gdansk"],
    105: ["Września"],
    106: ["Biala Podlaska"],
    107: ["Śrem"],
    108: ["Legionowo"],
    109: ["Bydgosz"],
    110: ["Łódź"],
    111: ["Liège"],
    185: ["Praha"],
    2005: ["Balti"],
    2006: ["Kishinev"],
    2007: ["Chișinău"],
    2008: ["Ungeni"],
    2009: ["Soroca"],
    3005: ["Bucuresti"]
};

const CITY_SORT = (() => {
  const m = new Map();
  for (const [rank, names] of Object.entries(CITY_SORT_GROUPS)) {
    for (const n of names) m.set(n, Number(rank));
  }
  return m;
})();
const CITY_SORT_LAST = 9999;

class StoresMap extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('[data-store-list]');
    this.empty = this.querySelector('[data-store-empty]');
    this.noresult = this.querySelector('[data-store-noresult]');
    this.search = this.querySelector('[data-store-search]');
    this.panel = this.querySelector('[data-store-panel]');
    this.head = this.querySelector('[data-store-head]');
    this.back = this.querySelector('[data-store-back]');
    this.crumb = this.querySelector('[data-store-crumb]');
    this.modal = this.querySelector('[data-store-modal]');

    this.zoom = Number(this.dataset.zoom) || 4;
    this.cityZoom = Number(this.dataset.cityZoom) || 11;
    this.pointZoom = Number(this.dataset.pointZoom) || 16;
    this.center = this.dataset.center || '50.069377,10.153333';
    this.shopOne = this.dataset.shopOne || 'shop';
    this.shopMany = this.dataset.shopMany || 'shops';
    this.allLabel = this.dataset.allLabel || 'All markets';
    this.marketsEl = this.querySelector('[data-store-markets]');
    this.market = '';

    this.points = this.read();

    if (!this.points.length) {
      this.empty?.removeAttribute('hidden');
      return;
    }

    this.cities = this.group();
    this.renderMarkets();
    this.renderCities();

    this.initMaps();

    this.list?.addEventListener('click', (e) => {
      const card = e.target.closest('[data-city]');
      if (card) {
        this.openCity(card.dataset.city);
        return;
      }

      if (e.target.closest('a[href^="tel:"]')) return;
      const item = e.target.closest('[data-i]');
      if (item) this.openPoint(Number(item.dataset.i));
    });

    this.back?.addEventListener('click', () => { this.query = ''; if (this.search) this.search.value = ''; this.renderCities(); });

    this.marketsEl?.addEventListener('click', (e) => {
      const chip = e.target.closest('[data-market]');
      if (chip) this.applyMarket(chip.dataset.market);
    });

    if (this.marketsEl) this.dragScroll(this.marketsEl);

    this.query = '';
    this.search?.addEventListener('input', () => {
      this.query = this.search.value.trim().toLowerCase();
      if (this.back.hidden) this.renderCities();
      else this.openCity(this.crumb.textContent, { silent: true });
    });

    this.initModal();

    this.head?.addEventListener('click', (e) => {
      if (e.target.closest('[data-store-back]')) return;

      if (window.matchMedia('(max-width: 768px)').matches) {
        this.panel.classList.toggle('is-open');
      }
    });

    const fromUrl = new URLSearchParams(location.search).get('city');
    if (fromUrl && this.cities.some((c) => c.name === fromUrl)) {
      this.openCity(fromUrl, { silent: true });
    }
  }

  read() {
    const tag = this.querySelector('[data-stores]');
    try {
      return (JSON.parse(tag?.textContent || '[]') || [])
        .map((p, i) => ({ ...p, i }))
        .filter((p) => p.name);
    } catch (e) {
      console.warn('stores-map: не розібрав дані точок', e);
      return [];
    }
  }

  dragScroll(el) {
    let armed = false;
    let active = false;
    let startX = 0;
    let startLeft = 0;
    let shift = 0;

    el.addEventListener('click', (e) => {
      if (shift > 4) { e.preventDefault(); e.stopPropagation(); }
      shift = 0;
    }, true);

    el.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'touch' || e.button !== 0) return;
      if (el.scrollWidth <= el.clientWidth) return;
      armed = true;
      active = false;
      shift = 0;
      startX = e.clientX;
      startLeft = el.scrollLeft;
    });

    el.addEventListener('pointermove', (e) => {
      if (!armed) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > shift) shift = Math.abs(dx);
      if (!active) {
        if (shift <= 3) return;
        active = true;
        el.classList.add('is-dragging');
        try { el.setPointerCapture(e.pointerId); } catch (_) {}
      }
      el.scrollLeft = startLeft - dx;
    });

    const stop = (e) => {
      if (!armed) return;
      armed = false;
      if (active) {
        active = false;
        el.classList.remove('is-dragging');
        try { el.releasePointerCapture(e.pointerId); } catch (_) {}
      }
    };
    el.addEventListener('pointerup', stop);
    el.addEventListener('pointercancel', stop);
    el.addEventListener('lostpointercapture', stop);
  }

  markets() {
    const by = new Map();
    for (const p of this.points) {
      const c = p.country || '';
      if (!c) continue;
      by.set(c, (by.get(c) || 0) + 1);
    }
    return [...by.entries()].map(([name, count]) => ({ name, count }))
      .sort((a, b) => b.count - a.count || a.name.localeCompare(b.name));
  }

  renderMarkets() {
    if (!this.marketsEl) return;
    const list = this.markets();
    if (list.length < 2) { this.marketsEl.hidden = true; return; }
    this.marketsEl.hidden = false;
    const total = this.points.filter((p) => p.country).length;
    const chip = (market, label, count, active) =>
      `<button type="button" class="stores-map__market${active ? ' is-active' : ''}"` +
      ` data-market="${esc(market)}" role="tab" aria-selected="${active ? 'true' : 'false'}">` +
      `<span class="stores-map__market-name">${esc(label)}</span>` +
      `<span class="stores-map__market-count">${count}</span></button>`;
    this.marketsEl.innerHTML =
      chip('', this.allLabel, total, !this.market)
      + list.map((m) => chip(m.name, m.name, m.count, this.market === m.name)).join('');
  }

  applyMarket(market) {
    this.market = (this.market === market) ? '' : market;
    this.query = '';
    if (this.search) this.search.value = '';
    this.cities = this.group();
    this.renderMarkets();
    this.renderCities();
    this.filterMap();
  }

  filterMap() {
    if (!this.map || !window.google) return;
    this.markers.forEach((m) => { m.__off = !!this.market && m.__country !== this.market; });
    this.recluster();
    const active = this.markers.filter((m) => !m.__off);
    if (this.market && active.length) {
      const b = new google.maps.LatLngBounds();
      active.forEach((m) => b.extend(m.getPosition()));
      this.map.fitBounds(b);
      if (active.length === 1) this.map.setZoom(this.pointZoom);
    } else {
      this.show(this.center, this.zoom);
    }
  }

  group() {
    const by = new Map();
    for (const p of this.points) {
      if (this.market && (p.country || '') !== this.market) continue;
      const city = p.city || '';
      if (!city) continue;
      if (!by.has(city)) by.set(city, []);
      by.get(city).push(p);
    }
    return [...by.entries()].map(([name, items]) => {
      const geo = items.filter((p) => p.lat && p.lng);
      const lat = geo.reduce((s, p) => s + Number(p.lat), 0) / (geo.length || 1);
      const lng = geo.reduce((s, p) => s + Number(p.lng), 0) / (geo.length || 1);
      return { name, items, lat, lng };
    }).sort((a, b) => {
      const ra = CITY_SORT.has(a.name) ? CITY_SORT.get(a.name) : CITY_SORT_LAST;
      const rb = CITY_SORT.has(b.name) ? CITY_SORT.get(b.name) : CITY_SORT_LAST;
      return ra - rb || a.name.localeCompare(b.name);
    });
  }

  hit(p) {
    if (!this.query) return true;
    return [p.name, p.address, p.city].some(
      (v) => v && String(v).toLowerCase().includes(this.query));
  }

  renderCities() {
    this.crumb.textContent = '';
    this.back.hidden = true;

    const cities = this.cities.filter(
      (c) => !this.query || c.name.toLowerCase().includes(this.query) || c.items.some((p) => this.hit(p)));
    this.list.innerHTML = cities.map((c) => `
      <li class="stores-map__item" data-city="${esc(c.name)}">
        <span class="stores-map__item-title">${esc(c.name)}</span>
        <span class="stores-map__item-count">${c.items.length} ${c.items.length === 1 ? this.shopOne : this.shopMany}</span>
      </li>`).join('');

    this.empty?.toggleAttribute('hidden', this.cities.length > 0);
    this.noresult?.toggleAttribute('hidden', !(this.query && cities.length === 0));
    this.show(this.center, this.zoom);
    this.sync('');
  }

  openCity(name, { silent = false } = {}) {
    const city = this.cities.find((c) => c.name === name);
    if (!city) return;
    this.crumb.textContent = city.name;
    this.back.hidden = false;

    const items = city.items.filter((p) => this.hit(p));
    this.noresult?.toggleAttribute('hidden', !(this.query && items.length === 0));
    this.list.innerHTML = items.map((p) => `
      <li class="stores-map__item" data-i="${p.i}">
        <span class="stores-map__point-title">${esc(p.name)}</span>
        ${p.address ? `<span class="stores-map__point-addr">${esc(p.address)}</span>` : ''}
        ${p.phone ? `<span class="stores-map__point-line stores-map__point-line--phone">
          <svg class="stores-map__ico" aria-hidden="true"><use xlink:href="#store-icon-phone"></use></svg>
          <a class="stores-map__point-value" href="tel:${esc(String(p.phone).replace(/[^\d+]/g, ''))}">${esc(p.phone)}</a>
        </span>` : ''}
        ${p.hours ? `<span class="stores-map__point-line stores-map__point-line--time">
          <svg class="stores-map__ico" aria-hidden="true"><use xlink:href="#store-icon-time"></use></svg>
          <span class="stores-map__point-value">${esc(p.hours)}</span>
        </span>` : ''}
      </li>`).join('');
    if (city.lat && city.lng) this.show(`${city.lat},${city.lng}`, this.cityZoom);
    if (!silent) this.sync(city.name);
  }

  openPoint(index) {
    const p = this.points.find((x) => x.i === index);
    if (!p) return;
    this.list.querySelectorAll('[data-i]').forEach((el) =>
      el.classList.toggle('is-active', Number(el.dataset.i) === index));

    this.openModal(p);
    if (p.lat && p.lng) this.show(`${p.lat},${p.lng}`, this.pointZoom, { pin: true });
  }

  initModal() {
    if (!this.modal) return;
    const close = this.modal.querySelector('[data-store-modal-close]');
    close?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.closeModal();
    });

    close?.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.closeModal(); }
    });

    document.addEventListener('click', (e) => {
      if (!this.modal.classList.contains('active')) return;
      if (this.modal.contains(e.target) || this.contains(e.target)) return;
      this.closeModal();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('active')) this.closeModal();
    });
  }

  openModal(p) {
    if (!this.modal) return;
    const q = (s) => this.modal.querySelector(s);

    const hasPhoto = !!p.photo && p.photo !== '/';
    const photoWrap = q('.photoWrap');
    if (photoWrap) photoWrap.hidden = !hasPhoto;
    const img = q('.jsMapWindow_photo');
    if (img && hasPhoto) {
      img.setAttribute('src', p.photo);
      img.setAttribute('alt', p.name || '');
    }

    const title = q('.jsMapWindow_title');
    if (title) title.textContent = p.name || '';
    const desc = q('.jsMapWindow_description');
    if (desc) desc.textContent = p.address || '';

    const tel = q('.jsMapWindow_telephone');
    if (tel) {

      tel.setAttribute('href', p.phone ? `tel:${String(p.phone).replace(/[^\d+]/g, '')}` : '#');
      tel.textContent = p.phone || '';
    }
    const time = q('.jsMapWindow_time_work');
    if (time) time.textContent = p.hours || '';

    this.modal.classList.add('active');
    this.modal.setAttribute('aria-hidden', 'false');

    if (window.matchMedia('(max-width: 768px)').matches) {
      this.panel?.classList.remove('is-open');
      this.panel?.classList.add('is-hidden');
    }
  }

  closeModal() {
    if (!this.modal) return;
    this.modal.classList.remove('active');
    this.modal.setAttribute('aria-hidden', 'true');
    this.panel?.classList.remove('is-hidden');

    this.list?.querySelectorAll('[data-i].is-active')
      .forEach((el) => el.classList.remove('is-active'));
  }

  initMaps() {
    this.canvas = this.querySelector('[data-store-canvas]');
    this.markers = [];
    this.clusterLayer = [];
    this.activeMarker = null;
    if (!this.canvas) return;
    const key = (this.dataset.mapsKey || '').trim();
    if (!key) { this.dataset.mapState = 'no-key'; return; }

    window.gm_authFailure = () => { this.dataset.mapState = 'auth-failed'; };
    window.__storesMapInit = () => { this.dataset.mapState = 'ready'; this.buildMap(); };
    const tag = document.createElement('script');
    tag.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key)
      + '&callback=__storesMapInit&loading=async&v=weekly';
    tag.async = true;
    tag.onerror = () => { this.dataset.mapState = 'script-error'; };
    document.head.appendChild(tag);
  }

  buildMap() {
    const [lat, lng] = String(this.center).split(',').map(Number);
    this.map = new google.maps.Map(this.canvas, {
      zoom: this.zoom, center: { lat, lng }, disableDefaultUI: true,

      styles: [
        { featureType: 'administrative', elementType: 'labels.text.fill', stylers: [{ color: '#444444' }] },
        { featureType: 'landscape', elementType: 'all', stylers: [{ color: '#f2f2f2' }] },
        { featureType: 'poi', elementType: 'all', stylers: [{ visibility: 'off' }] },
        { featureType: 'road', elementType: 'all', stylers: [{ saturation: -100 }, { lightness: 45 }] },
        { featureType: 'road.highway', elementType: 'all', stylers: [{ visibility: 'simplified' }] },
        { featureType: 'road.highway', elementType: 'geometry.fill', stylers: [{ color: '#ffffff' }] },
        { featureType: 'road.arterial', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
        { featureType: 'transit', elementType: 'all', stylers: [{ visibility: 'off' }] },
        { featureType: 'water', elementType: 'all', stylers: [{ color: '#dde6e8' }, { visibility: 'on' }] },
        { featureType: 'administrative.province', elementType: 'geometry.stroke', stylers: [{ visibility: 'off' }] },
      ],
    });

    this.gmap = this.map;

    const size = new google.maps.Size(34, 48);
    this.iconOff = { url: this.dataset.marker, scaledSize: size };
    this.iconOn = { url: this.dataset.markerActive, scaledSize: size };

    this.markers = this.points.filter((p) => p.lat && p.lng).map((p) => {
      const m = new google.maps.Marker({
        position: { lat: Number(p.lat), lng: Number(p.lng) },
        icon: this.iconOff, title: p.name,
      });
      m.__i = p.i;
      m.__country = p.country || '';
      m.addListener('mouseover', () => { if (m !== this.activeMarker) m.setIcon(this.iconOn); });
      m.addListener('mouseout', () => { if (m !== this.activeMarker) m.setIcon(this.iconOff); });

      m.addListener('click', () => this.openPoint(p.i));
      return m;
    });
    this.dataset.markers = String(this.markers.length);

    this.map.addListener('idle', () => this.recluster());
    this.map.addListener('zoom_changed', () => this.recluster());
    this.recluster();
  }

  clusterIcon() {
    const svg = '<svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">'
      + '<circle cx="17" cy="17" r="17" fill="black"/></svg>';
    return { url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
             scaledSize: new google.maps.Size(34, 34),
             labelOrigin: new google.maps.Point(17, 17) };
  }

  recluster() {
    if (!this.map) return;
    this.clusterLayer.forEach((c) => c.setMap(null));
    this.clusterLayer = [];

    const active = this.markers.filter((m) => !m.__off);
    this.markers.forEach((m) => { if (m.__off) m.setMap(null); });
    const zoom = this.map.getZoom();

    const report = (n) => {
      this.dataset.zoomLevel = String(zoom);
      this.dataset.clusters = String(n);
      this.dataset.loose = String(active.filter((m) => m.getMap()).length);
    };
    const proj = this.map.getProjection();
    if (zoom == null || zoom > 15 || !proj) {
      active.forEach((m) => m.setMap(this.map));
      report(0);
      return;
    }
    const scale = Math.pow(2, zoom);
    const cells = new Map();
    active.forEach((m) => {
      const wp = proj.fromLatLngToPoint(m.getPosition());
      const key = Math.floor(wp.x * scale / 60) + '|' + Math.floor(wp.y * scale / 60);
      let bucket = cells.get(key);
      if (!bucket) { bucket = []; cells.set(key, bucket); }
      bucket.push(m);
    });
    cells.forEach((group) => {
      if (group.length === 1) { group[0].setMap(this.map); return; }
      group.forEach((m) => m.setMap(null));
      const lat = group.reduce((s, m) => s + m.getPosition().lat(), 0) / group.length;
      const lng = group.reduce((s, m) => s + m.getPosition().lng(), 0) / group.length;
      const c = new google.maps.Marker({
        position: { lat, lng }, map: this.map, icon: this.clusterIcon(),
        label: { text: String(group.length), color: '#fff', fontSize: '18px' },
        zIndex: 10000,
      });
      c.addListener('click', () => {
        this.map.panTo({ lat, lng });
        this.map.setZoom(Math.min((this.map.getZoom() || this.zoom) + 3, 16));
      });
      this.clusterLayer.push(c);
    });
    report(this.clusterLayer.length);
  }

  show(center, zoom, { pin = false } = {}) {
    if (!this.map) return;
    const [lat, lng] = String(center).split(',').map(Number);
    if (!isFinite(lat) || !isFinite(lng)) return;
    this.map.setCenter({ lat, lng });
    this.map.setZoom(zoom);
    if (this.activeMarker) { this.activeMarker.setIcon(this.iconOff); this.activeMarker = null; }
    if (!pin) return;

    const m = this.markers.find((x) => Math.abs(x.getPosition().lat() - lat) < 1e-6
      && Math.abs(x.getPosition().lng() - lng) < 1e-6);
    if (m) { m.setIcon(this.iconOn); this.activeMarker = m; }
  }

  sync(city) {
    const url = new URL(location.href);
    if (city) url.searchParams.set('city', city);
    else url.searchParams.delete('city');
    history.replaceState({}, '', url);
  }
}

function esc(s) {
  return String(s == null ? '' : s).replace(/[<>&"]/g, (c) =>
    ({ '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' }[c]));
}

customElements.define('stores-map', StoresMap);
